module.exports = __webpack_public_path__ + "static/img/cont56 (4).9df4986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (4).jpg
// module id = wws6
// module chunks = 0